import {Component, NgZone, OnDestroy, OnInit} from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.css']
})
export class RootComponent implements OnInit, OnDestroy {

  private readonly onWheel = () => {
    const activeElement = document.activeElement;
    if (activeElement instanceof HTMLInputElement && activeElement.type === 'number') {
      activeElement.blur();
    }
  };

  constructor(private _zone: NgZone) { }

  ngOnInit() {
    this._zone.runOutsideAngular(() => {
      document.addEventListener('wheel', this.onWheel, {passive: true});
    });
  }

  ngOnDestroy(): void {
    document.removeEventListener('wheel', this.onWheel);
  }

}
